import apiClient from '../axiosInstance';
import { API_BASE_ADDRESS } from '../api';

const creditChangeCheckService = (action: any) => {
  const memberId = action.member_id;

  return {
    getCreditChangeCheck: () => apiClient.get(`${API_BASE_ADDRESS}/mypage/credit/change/check?member_id=${memberId}`),
  };
};

export default creditChangeCheckService;
